export default "__VITE_ASSET__C4AmQSI2__"